// hooks/useLogout.js
import { useNavigate } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const useLogout = () => {
  const navigate = useNavigate();

  const logout = async (reason = "logout") => {
    try {
      const token = localStorage.getItem("token");
      const sessionId = localStorage.getItem("sessionId");

      if (token && sessionId) {
        const payload = {
          sessionId: Number(sessionId),
          logoutAt: new Date().toISOString(),
          reason,
        };

        // Cierra la sesión de tiempo en el backend
        await fetch(`${API_BASE_URL}/api/tiempos/session/end`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
          keepalive: true, // asegura el envío incluso si se navega de inmediato
        });
      }
    } catch (e) {
      // No bloquea el cierre de sesión aunque falle el tracking de tiempo
      console.error("No se pudo finalizar la sesión de tiempo:", e);
    } finally {
      // Limpiar credenciales y sessionId SIEMPRE
      localStorage.removeItem("sessionId");
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");

      // Redirigir al login
      navigate("/login");
    }
  };

  return logout;
};

export default useLogout;
